import React from "react";
import ReactMarkdown, {Components} from "react-markdown";
import {useLinkHandler} from "../../../app/hooks/useLinkHandler";

interface BotTextMessageProps {
    text?: string
}

export const TextInMarkdown: React.FC<BotTextMessageProps> = ({
                                                                  text
                                                              }) => {

    const {openLink} = useLinkHandler();

    const components = {
        // @ts-ignore
        a: ({href, children}) => {
            return (
                <a
                    href={href}
                    style={{textDecoration: "underline"}}
                    onClick={(e) => openLink(href, true, e)}
                >
                    {children}
                </a>
            );
        },
    } as Components;

    // Regex to detect bare URLs not already inside Markdown links
    const urlRegex = /(?<!\]\()https?:\/\/[^\s]+/g;

    // Replace plain URLs with a Markdown link: [link](URL)
    const processedMessage = text?.replace(urlRegex, (url) => {
        return `[link](${url})`;
    });

    return <ReactMarkdown components={components}>
        {processedMessage}
    </ReactMarkdown>
}
